import React, { FC } from 'react';
import { Progress } from 'antd';
import { EMetricType, EMetricTypeLabel, Metric } from 'common/models/commonModel';
import { priceFormatter } from 'common/helpers/format.helper';
import { Target } from 'common/svg';

interface IMetricOverviewProps {
  type: EMetricType;
  metric?: Metric;
}

export const MetricOverview: FC<IMetricOverviewProps> = ({ type, metric }) => {
  const isTransactionCount = type === EMetricType.TransactionCount;

  if (!metric) {
    return null;
  }

  return (
    <div>
      <div className="flex flex-align-center flex-justify-between">
        <span>
          <span className="mr-3 ff-regular fs-xxs">{EMetricTypeLabel[type]}</span>
          <span className="ff-regular fs-xxs color-gray-1">
            {isTransactionCount ? metric.actual : priceFormatter(metric.actual)}
          </span>
          {metric.percent && (
            <>
              <span className="ff-regular fs-xxs color-gray-1"> • </span>
              <span className="ff-medium fs-xxs color-purple">{metric.percent}%</span>
            </>
          )}
        </span>

        {metric.target && (
          <span className="flex flex-align-center">
            <Target />
            <span className="ml-2 ff-regular fs-xxs color-gray-1">
              {isTransactionCount ? metric.target : priceFormatter(metric.target)}
            </span>
          </span>
        )}
      </div>

      <Progress showInfo={false} percent={metric.percent ?? 0} />
    </div>
  );
};
